import Splide from '@splidejs/splide';
// import {AutoScroll} from '@splidejs/splide-extension-auto-scroll';
( function( app ) {
  const COMPONENT = {
    init: function() {
      if ( $( '.image-marquee__splide' ).length ) {
        $( '.image-marquee__splide' ).each( function( index, element ) {
          const slider = new Splide( $( element )[0], {
            type: 'loop',
            arrows: true,
            perPage: 2,
            perMove: 1,
            gap: '1.25rem',
            pagination: false,
            breakpoints: {
              1024: {
                perPage: 1,
              },
            },
            // autoScroll: {
            //   speed: .75,
            //   pauseOnFocus: false,
            //   pauseOnHover: false,
            // },
          } );
          slider.mount();
        } );
      }
    },
    finalize: function() {
    },
  };

  app.registerComponent( 'image-marquee', COMPONENT );
} )( app );
